skyward.base.registerScript("contentMessageArea", (function (skyward, $)
{
    skyward.contentMessageArea = skyward.contentMessageArea || {};

    var contentMessageAreasByElement = new WeakMap();
    var contentMessageAreasByParent = new WeakMap();
    var defaultConfirmationMessage = 'The information has been successfully saved.';

    var getBaseMessage = function ()
    {
        var baseMessage = {};

        baseMessage.message = undefined;

        baseMessage.show = function ()
        {
            if (baseMessage.message)
            {
                baseMessage.message.removeClass('cmaHidden');
            }
            return baseMessage;
        };

        baseMessage.hide = function (animate)
        {
            if (baseMessage.message)
            {
                if (animate)
                {
                    baseMessage.message.animate({ 'opacity': 0 },
                    {
                        complete: function ()
                        {
                            baseMessage.message.addClass('cmaHidden');
                        }
                    });
                }
                else
                {
                    baseMessage.message.addClass('cmaHidden');
                }
            }

            return baseMessage;
        };

        baseMessage.reset = function ()
        {
            return baseMessage.hide();
        };

        baseMessage.isVisible = function ()
        {
            return baseMessage.message && !baseMessage.message.hasClass('cmaHidden');
        };

        return baseMessage;
    };

    var getErrorWarningBaseMessage = function ()
    {
        var baseMessage = getBaseMessage();

        baseMessage.countSpan = undefined;
        baseMessage.confirmButtonNameSpan = undefined;

        var count = 0;
        var confirmButtonName = "Save";

        baseMessage.setCount = function (newCount)
        {
            if (baseMessage.countSpan)
            {
                baseMessage.countSpan.text(newCount);
                count = newCount;

                baseMessage.message.find('.subjectVerbAgreementSpan').each(function ()
                {
                    var subjectVerbAgreementSpan = $(this);
                    var subjectVerbAgreementSpanData = subjectVerbAgreementSpan.data();

                    if (newCount > 1)
                    {
                        subjectVerbAgreementSpan.text(subjectVerbAgreementSpanData['plural']);
                    }
                    else
                    {
                        subjectVerbAgreementSpan.text(subjectVerbAgreementSpanData['singular']);
                    }
                });
            }

            return baseMessage;
        };

        baseMessage.getCount = function ()
        {
            return count;
        };

        baseMessage.setConfirmButtonName = function (newConfirmButtonName)
        {
            if (baseMessage.confirmButtonNameSpan)
            {
                baseMessage.confirmButtonNameSpan.text(newConfirmButtonName);
                confirmButtonName = newConfirmButtonName;
            }

            return baseMessage;
        };

        baseMessage.getConfirmButtonName = function ()
        {
            return confirmButtonName;
        };

        baseMessage.reset = function ()
        {
            return baseMessage.hide().setCount(0).setConfirmButtonName("Save");
        };

        return baseMessage;
    };

    var getErrorMessage = function (contentMessageArea)
    {
        var messageObject = getErrorWarningBaseMessage();
        var errorMessage = contentMessageArea.find('.cmaErrorMessage');
        var baseReset = messageObject.reset;

        if (errorMessage.length === 0)
        {
            return messageObject;
        }

        messageObject.message = errorMessage;
        messageObject.countSpan = messageObject.message.find('.countSpan');
        messageObject.confirmButtonNameSpan = messageObject.message.find('.confirmButtonNameSpan');
        messageObject.allErrorsAreHidden = false;
        messageObject.reset = function ()
        {
            messageObject.allErrorsAreHidden = false;
            baseReset();
        };

        setAdditionalInformationBubbleClick(messageObject);

        return messageObject;
    };

    var getWarningMessage = function (contentMessageArea)
    {
        var messageObject = getErrorWarningBaseMessage();
        var warningMessage = contentMessageArea.find('.cmaWarningMessage');

        if (warningMessage.length === 0)
        {
            return messageObject;
        }

        messageObject.message = warningMessage;
        messageObject.countSpan = messageObject.message.find('.countSpan');
        messageObject.confirmButtonNameSpan = messageObject.message.find('.confirmButtonNameSpan');

        setAdditionalInformationBubbleClick(messageObject);
        return messageObject;
    };

    var getConfirmationMessage = function (contentMessageArea, contentMessageAreaContainer)
    {
        var messageObject = getBaseMessage();
        messageObject.hasValue = false;
        messageObject.isStandalone = false;

        var confirmationMessage = contentMessageArea.find('.cmaConfirmationMessage');
        if (confirmationMessage.length === 0)
        {
            messageObject.isStandalone = true;
            confirmationMessage = contentMessageAreaContainer.find('.cmaConfirmationMessage').filter(function ()
            {
                return !contentMessageAreasByElement.has(this);
            })
            .first();
        }
        if (confirmationMessage.length === 0)
        {
            return messageObject;
        }
        contentMessageAreasByElement.set(confirmationMessage[0], messageObject);
        messageObject.message = confirmationMessage;
        var messageContainer = confirmationMessage.find('.cmaMessage');
        messageObject.hasValue = confirmationMessage.hasClass('cmaHasValue');

        var animateConfirmationMessage = confirmationMessage.hasClass('js-animateConfirmationMessage');

        var base =
        {
            show: messageObject.show,
            hide: messageObject.hide,
            isVisible: messageObject.isVisible
        };

        messageObject.hide = function ()
        {
            if (!animateConfirmationMessage)
            {
                base.hide();
                toggleSiblings(true);
                return messageObject;
            }

            messageObject.message.animate({ 'opacity': 0 },
            {
                complete: function ()
                {
                    if (messageObject.isStandalone)
                    {
                        base.hide(false);
                        toggleSiblings(true);
                    }
                    contentMessageArea.trigger("CMAConfirmationHidden");
                }
            });

            return messageObject;
        };
        messageObject.show = function ()
        {
            if (animateConfirmationMessage)
            {
                messageObject.message.attr("aria-hidden", true);
                messageObject.message.attr("aria-busy", true);
            }

            if (messageObject.isStandalone || !animateConfirmationMessage)
            {
                toggleSiblings(false);
                base.show();
            }

            if (!animateConfirmationMessage)
            {
                return messageObject;
            }

            messageObject.message.animate({ 'opacity': 1 },
            {
                complete: function ()
                {
                    messageObject.message.attr("aria-busy", false);
                    messageObject.message.attr("aria-hidden", false);
                    window.setTimeout(function ()
                    {
                        messageObject.hide();
                        contentMessageArea.trigger("SaveAnimationRedirect");
                    }, 3000);
                }
            });

            return messageObject;
        };
        messageObject.reset = function ()
        {
            messageObject.hide();
            messageContainer.html('');
            messageObject.message.removeClass('cmaHasValue');
            messageObject.hasValue = false;
            return messageObject;
        };
        messageObject.setMessage = function (message)
        {
            messageContainer.html(message);
            messageObject.message.addClass('cmaHasValue');
            messageObject.hasValue = true;
            return messageObject;
        };
        messageObject.isVisible = function ()
        {
            return !messageObject.isStandalone && base.isVisible();
        };

        // There's a bug in IE 11 where absolutely positioned items in flex containers are incorrectly
        // treated like flex items. To get around this we'll have to instead swap showing the
        // toolbar left and right with the confirmation message.
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12500543/
        function toggleSiblings(show)
        {
            if (skyward.global.mobileAccess)
            {
                return;
            }

            messageObject.message.siblings().toggle(show);
        }

        return messageObject;
    };

    var getGenericMessage = function (contentMessageArea, className)
    {
        var messageObject = getBaseMessage();
        var information = contentMessageArea.find(className);
        if (information.length === 0)
        {
            return messageObject;
        }
        messageObject.message = information;
        var messageContainer = information.find('.cmaMessage');
        messageObject.reset = function ()
        {
            messageObject.hide();
            messageContainer.html('');
            return messageObject;
        };
        messageObject.setMessage = function (message)
        {
            messageContainer.html(message);
            return messageObject;
        };

        setAdditionalInformationBubbleClick(messageObject);
        return messageObject;
    };

    var setAdditionalInformationBubbleClick = function (messageObject)
    {
        messageObject.message.off("click").click(function (e)
        {
            if ($(e.target).closest("a,button").length !== 0)
            {
                return;
            }

            var message = messageObject.message.find(".cmaMessage");
            var messageText = message.find(".cmaMessageText");
            var popupText = messageText.length === 0 ? message.text() : messageText.text();

            skyward.modalLayer.showDialog("Additional Information", skyward.extensions.encodeHtml(popupText), [{ text: "Close", icon: "Close" }],
            {
                anchorTo: messageObject.message.find(".svg")
            });
        });
    };

    var getContentMessageAreaObject = function (contentMessageAreaElement, contentMessageAreaContainer)
    {
        var contentMessageAreaObject = {};

        var contentMessageArea = contentMessageAreaElement;
        var errorMessage = getErrorMessage(contentMessageArea);
        var warningMessage = getWarningMessage(contentMessageArea);
        var confirmationMessage = getConfirmationMessage(contentMessageArea, contentMessageAreaContainer);
        var scopeMessage = getGenericMessage(contentMessageArea, '.cmaScopeMessage');
        var informationMessage = getGenericMessage(contentMessageArea, '.cmaInformationMessage');

        contentMessageAreaObject.getContentMessageAreaElement = function ()
        {
            return contentMessageArea;
        };

        var updateVisibility = function ()
        {
            var cmaHidden = contentMessageArea.hasClass("cmaHidden");
            var cmaVisible = contentMessageArea.is(":visible");
            var messagesVisible = !!(errorMessage.isVisible() || warningMessage.isVisible() || confirmationMessage.isVisible() || scopeMessage.isVisible() || informationMessage.isVisible());
            if (!cmaHidden && cmaVisible !== messagesVisible)
            {
                contentMessageArea.toggle(messagesVisible);
                /* Some layouts may be affected by showing/hiding the contentMessageArea.
                 * Trigger a window resize to force redrawing affected areas.*/
                $(window).resize();
            }
        };
        updateVisibility();

        contentMessageAreaObject.resetValidation = function ()
        {
            errorMessage.reset();
            warningMessage.reset();
            updateVisibility();
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.resetConfirmation = function ()
        {
            confirmationMessage.reset();
            updateVisibility();
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.resetInformation = function ()
        {
            informationMessage.reset();
            updateVisibility();
            return contentMessageAreaObject;
        };

        contentMessageAreaObject.hideScope = function (animate)
        {
            scopeMessage.hide(animate);
            updateVisibility();
        };

        contentMessageAreaObject.hideInformation = function (animate)
        {
            informationMessage.hide(animate);
            updateVisibility();
        };

        contentMessageAreaObject.setScopeMessage = function (message)
        {
            scopeMessage.setMessage(message);
            updateVisibility();
        };

        contentMessageAreaObject.setInformationMessage = function (message)
        {
            informationMessage.setMessage(message);
            updateVisibility();
        };
        contentMessageAreaObject.setConfirmationMessage = function (message)
        {
            if (confirmationMessage.setMessage)
            {
                confirmationMessage.setMessage(message);
            }
            updateVisibility();
        };
        contentMessageAreaObject.setValidationCount = function (errorCount, warningCount)
        {
            errorMessage.setCount(errorCount);
            warningMessage.setCount(warningCount);
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.getValidationCount = function ()
        {
            const count =
            {
                errorCount: errorMessage.getCount(),
                warningCount: warningMessage.getCount()
            };
            return count;
        };
        contentMessageAreaObject.modifyValidationCount = function (errorChangeArg = 0, warningChangeArg = 0)
        {
            const errorChange = isFinite(errorChangeArg) ? errorChangeArg : 0;
            const warningChange = isFinite(warningChangeArg) ? warningChangeArg : 0;
            const { errorCount, warningCount } = this.getValidationCount();
            if (errorCount + errorChange < 0)
            {
                console.warn(`Reducing error count by ${errorChange} but there are only ${errorCount} errors`);
            }
            if (warningCount + warningChange < 0)
            {
                console.warn(`Reducing warning count by ${warningChange} but there are only ${warningCount} warnings`);
            }
            const newErrorCount = Math.max(errorCount + errorChange, 0);
            const newWarningCount = Math.max(warningCount + warningChange, 0);
            this.setValidationCount(newErrorCount,newWarningCount);
            // don't show validation if error count is newly > 0, the confirm button name may not have been initialized yet
            if (newErrorCount === 0 && newWarningCount === 0)
            {
                this.resetValidation();
            }
            return { errorCount: newErrorCount, warningCount: newWarningCount };
        }
        contentMessageAreaObject.setConfirmButtonName = function (confirmButtonName)
        {
            errorMessage.setConfirmButtonName(confirmButtonName);
            warningMessage.setConfirmButtonName(confirmButtonName);
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.setAllErrorsAreHidden = function (allErrorsAreHidden)
        {
            errorMessage.allErrorsAreHidden = !!allErrorsAreHidden;
            return contentMessageAreaObject;
        };

        contentMessageAreaObject.showValidation = function ()
        {
            if ((errorMessage.getCount() === 0 && errorMessage.allErrorsAreHidden === true) || errorMessage.getCount() > 0)
            {
                if (errorMessage.allErrorsAreHidden === true)
                {
                    errorMessage.message.find(".cmaMessageText").text("Errors were encountered while attempting to Save. Please contact your Skyward Administrator.")
                }
                errorMessage.setConfirmButtonName(contentMessageArea.attr("data-last-button-clicked-name"));
                errorMessage.show();
            }

            if (warningMessage.getCount() > 0)
            {
                warningMessage.setConfirmButtonName(contentMessageArea.attr("data-last-button-clicked-name"));
                warningMessage.show();
            }

            updateVisibility();

            return contentMessageAreaObject;
        };
        contentMessageAreaObject.showConfirmation = function ()
        {
            if (confirmationMessage.hasValue)
            {
                confirmationMessage.show();
            }

            updateVisibility();
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.showScope = function ()
        {
            scopeMessage.show();
            updateVisibility();
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.showInformation = function ()
        {
            informationMessage.show();
            updateVisibility();
            return contentMessageAreaObject;
        };

        return contentMessageAreaObject;
    };

    skyward.contentMessageArea.getContentMessageArea = function (container)
    {
        var contentMessageArea;

        contentMessageArea = contentMessageAreasByParent.get(container[0]);
        if (contentMessageArea)
        {
            return contentMessageArea;
        }
        // fallback in case the content message area hasn't been initialized yet
        return addContentMessageArea(container.children(".contentMessageArea").first());
    };

    var addContentMessageArea = function (element)
    {
        if (element.length === 0)
        {
            return null;
        }
        var container = element.parent();
        contentMessageAreasByParent.delete(container[0]);

        var contentMessageAreaElement;
        if (skyward.global.mobileAccess && container.hasClass('js-mobileToolbarControlledContent'))
        {
            contentMessageAreaElement = container.siblings('.js-mobileDetailsCMA').first();
        }
        else
        {
            contentMessageAreaElement = element;
        }

        if (contentMessageAreaElement.length > 0)
        {
            var cmaObject = getContentMessageAreaObject(contentMessageAreaElement, container);
            contentMessageAreasByParent.set(container[0], cmaObject);
            cmaObject.showConfirmation();
            return cmaObject;
        }
        else
        {
            return null;
        }
    };

    skyward.contentMessageArea.getDefaultConfirmationMessage = function ()
    {
        return defaultConfirmationMessage;
    };

    var initMessagesOnLoad = function ()
    {
        const elem = $(this);
        const cmaObj = addContentMessageArea(elem);
        // nullable lookup in case browse.js is not part of the bundle
        const browse = skyward.browse?.getContainingBrowse(elem);

        if (browse && !browse.contentMessageArea)
        {
            browse.contentMessageArea = cmaObj;
        }

        elem.parent().find(".toolbar a.button:not(.cancel)").off("click.cma").on("click.cma", function ()
        {
            cmaObj.getContentMessageAreaElement().attr("data-last-button-clicked-name", $(this).find("span.anchorText").text());
        });
    };

    return { init: initMessagesOnLoad };
}));